module.exports = __webpack_public_path__ + "static/img/howitworks.016949d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/svg/howitworks.svg
// module id = 650
// module chunks = 1